module.exports = __webpack_public_path__ + "static/img/todomath_main_feature_mode_ko.1334746.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/todomath_main_feature_mode_ko.png
// module id = vuga
// module chunks = 18